// extracted by mini-css-extract-plugin
module.exports = {"gcp-logo":"gcpLogo-module__gcp-logo___dFPTL","gcp-logo--sg":"gcpLogo-module__gcp-logo--sg___3gkM1","gcp-logo--gcp":"gcpLogo-module__gcp-logo--gcp___2lC4R"};